/**
 * 악덕알리미 제보 작성 (멀티스텝).
 *  Step1 업체정보+피해경위 → Step2 증빙사진+동의+본인인증 → 제출 → Step3 완료
 *  폼 구조는 Blade, 동작(스텝/검증/업로드/우편번호/제출)은 여기서.
 *  본인인증 — 처음(2026-05)엔 본앱 로그인 위임이라 뺐다가, 기획 시안(akalarmi-v5 "동의 및 인증")대로
 *  2026-09-11 추가. 회원 휴대폰(본앱 내정보)으로 알림톡 인증번호 6자리 → 확인 → 제출 가능.
 *  서버(ReportController)가 회원 번호 대조·코드 보관·제출 게이트를 맡고, 여기선 화면 상태만 다룬다.
 *  반려 재제출은 동의와 같이 생략(#b-agree-section 통째 숨김).
 */
import Util from '../../Common/Util';

const MAX_PHONES = 1;   // 대표번호 1개만 (추가번호 등록 불가 — 대표 지적)
const MAX_PHOTOS = 10;

export default class Report {
    constructor() {
        this.step = 1;
        this.phones = [''];
        this.agreed = [false, false, false];
        this.imgIds = [];
        this.draftNum = 0;   // 임시저장(DRAFT) 번호
        this.authSent = false;      // 인증번호 발송됨(인증번호 칸 열림)
        this.authVerified = false;  // 인증 통과 — 서버 세션과 같은 값. 제출 조건
        this.authSkipped = false;   // 반려 재제출 — 첫 제출 때 이미 인증(prefill 에서 켬)
        this.authTimer = null;
    }

    initialize() {
        this.$root = $('.b-report');
        this.editNum = parseInt(this.$root.data('edit-num'), 10) || 0;
        this.draftNum = this.editNum;  // 진입 시 로드된 임시건을 이어서 갱신

        this.renderPhones();
        this.bindPhones();
        this.bindPostcode();
        this.bindPhotos();
        this.bindAgree();
        this.bindAuth();
        this.bindKeyboardScroll();
        this.bindNav();
        this.bindWorkDay();
        this.bindCarType();
        this.bindAmount();
        this.bindBizNo();
        this.bindTarget();
        this.bindFormWatch();

        this.updateNextBtn();   // 초기 버튼 상태(빈 폼 → 비활성)

        if (this.editNum) this.prefill(this.editNum);
    }

    /* ── 하단 버튼 활성화 (필수항목 충족 시) ───────── */
    bindFormWatch() {
        // step1 입력 필드 + 전화행 변경 시 버튼 상태 갱신 (select/주소록/우편번호는 change 발생)
        this.$root.on('input change', '.b-rstep[data-step="1"] .b-input, #b-phones .b-phone',
            () => this.updateNextBtn());
    }

    isStep1Complete() {
        const v = (name) => (this.$root.find(`[name="${name}"]`).val() || '').trim();
        const required = [...this.requiredNameFields(), 'damage_day', 'car_type', 'work_place', 'unpaid_amount', 'damage_desc'];
        if (!required.every((n) => v(n))) return false;
        return !!($('#b-phones .b-phone').eq(0).val() || '').trim();
    }

    isStep2Complete() {
        return this.imgIds.length > 0 && this.agreed.every(Boolean) && this.isAuthOk();
    }

    // 본인인증 조건 — 반려 재제출(동의 구간 숨김)은 인증도 생략(서버 store() 도 같은 규칙)
    isAuthOk() {
        return this.authVerified || this.authSkipped;
    }

    updateNextBtn() {
        let ok = true;
        if (this.step === 1) ok = this.isStep1Complete();
        else if (this.step === 2) ok = this.isStep2Complete();
        // 네이티브 disabled 대신 클래스만 — 비활성처럼 보이되 클릭은 받아 부족항목 안내
        $('#b-rnext').toggleClass('is-disabled', !ok);
    }

    /* ── 작업일 (Mobiscroll 캘린더) ───────────────── */
    bindWorkDay() {
        const $d = this.$root.find('[name="damage_day"]');
        if (!$d.length || typeof $d.mobiscroll !== 'function') return;
        $d.mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            // 앱 테마를 따른다(라이트 고정이던 것을 2026-09 다크모드 점검에서 변경) — 다크 화면 위 흰 달력이 흰 덩어리로 떴다.
            // 다크 배색은 vendors/_mobiscroll.scss 의 [data-theme=dark] 블록이 우리 토큰으로 다시 칠한다 (장비불러 F/Mobile/Theme.syncMobiscroll 과 같은 원리).
            themeVariant: document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light',
            max: new Date(),   // 작업일은 미래 불가
            buttons: [],       // 날짜 탭 시 즉시 선택·닫힘
            onChange: () => this.updateNextBtn(),
        });
    }

    /* ── 키보드에 가려진 입력칸 끌어올리기 ──────────────────────────── */
    // 앱 웹뷰는 adjustResize — 키보드가 뜨면 뷰포트가 줄고, 스크롤은 안쪽 .b-scroll 이 맡는다. 화면 하단 근처 칸(기타 장비명·상세주소·
    // 피해내용 등)에 포커스하면 줄어든 뷰포트 밖 + 고정 '다음' 바 뒤에 남아 안 보인다. 키보드 애니메이션(약 300ms)이 끝난 뒤
    // 포커스된 칸을 하단 고정 바 **위로** 올린다.
    //
    // block:'center' 로는 모자랐다(2026-10-06 상필 님 QA, Z Flip4 브라우저) — 스크롤 영역의 가운데는 '바를 뺀 가운데'가
    // 아니라서, 피해내용처럼 키가 큰 칸은 가운데에 맞춰도 아래 절반이 바 뒤로 들어간다. 그래서 가운데가 아니라
    // **칸의 아래끝이 바 위 BAR_SAFE 선 위로 오도록** 직접 스크롤을 민다. 칸이 영역보다 크면 아래끝(= 커서가 있는 쪽)을 살린다.
    bindKeyboardScroll() {
        const BAR_SAFE = 68;   // 고정 바 56px + 여유 12px
        let timer = null;
        const lift = (el) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (document.activeElement !== el) return;
                const sc = el.closest ? el.closest('.b-scroll') : null;
                if (!sc) { if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
                const r = el.getBoundingClientRect();
                const s = sc.getBoundingClientRect();
                const limit = s.bottom - BAR_SAFE;                    // 이 선보다 아래면 바에 가린다
                if (r.bottom > limit)      sc.scrollTop += (r.bottom - limit) + 8;
                else if (r.top < s.top + 8) sc.scrollTop -= (s.top + 8 - r.top);
            }, 350);
        };
        this.$root.on('focusin', 'input, textarea, select', (e) => lift(e.target));
        // 키보드가 나중에 커지거나(추천어 줄) 뷰포트가 다시 줄 때도 한 번 더
        if (window.visualViewport) window.visualViewport.addEventListener('resize', () => {
            const el = document.activeElement;
            if (el && this.$root[0].contains(el) && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) lift(el);
        });
    }

    /* ── 작업장비 (이미지 타일 선택 + 기타 직접입력) ───────────────── */
    bindCarType() {
        const $hidden = this.$root.find('[name="car_type"]');
        const $etc = this.$root.find('#b-eq-etc-input');

        this.$root.on('click', '.b-eq', (e) => {
            const $t = $(e.currentTarget);
            const isEtc = $t.hasClass('b-eq--etc');
            this.$root.find('.b-eq').removeClass('on');
            $t.addClass('on');

            if (isEtc) {
                // '기타' → 입력칸 노출. car_type 은 입력값이 곧 값(덮어쓰기)이라
                //   입력 전엔 비워 둔다 → 필수검증에 걸려 다음 버튼이 막힌다.
                $etc.prop('hidden', false);
                $hidden.val($etc.val().trim()).removeClass('is-invalid');
                // 바로 입력하게 포커스 — 키보드가 올라오면(앱 adjustResize 로 화면이 줄어든다) 칸이 하단 '다음' 바·키보드 뒤에 숨어
                // 보이지 않던 것(2026-09-11 상필 님 QA). 포커스 → focusin 핸들러(bindKeyboardScroll)가 키보드 애니메이션 뒤 화면 가운데로 올린다.
                setTimeout(() => $etc.trigger('focus'), 50);
                $etc.trigger('focus');
            } else {
                // 정규 장비 → 입력칸 숨김 + 초기화, car_type 은 타일 이름.
                $etc.prop('hidden', true).val('');
                $hidden.val($t.data('eq')).removeClass('is-invalid');
            }
            this.updateNextBtn();
        });

        // 기타 입력 중에는 입력값이 그대로 car_type 이 된다.
        $etc.on('input', () => {
            $hidden.val($etc.val().trim()).removeClass('is-invalid');
            this.updateNextBtn();
        });
    }

    // 정규 장비 타일 이름 목록(기타 제외) — 복원 시 기타 여부 판별용.
    knownEqNames() {
        return this.$root.find('.b-eq').not('.b-eq--etc')
            .map((_, el) => String($(el).data('eq'))).get();
    }

    // 프리필/복원 시 hidden 값에 맞는 타일을 선택표시.
    //   값이 정규 장비면 그 타일을, 아니면(임의 텍스트) '기타' 타일 + 입력칸 복원.
    syncCarTypeTile() {
        const v = String(this.$root.find('[name="car_type"]').val() || '').trim();
        const $etc = this.$root.find('#b-eq-etc-input');
        this.$root.find('.b-eq').removeClass('on');
        $etc.prop('hidden', true).val('');
        if (!v) return;

        if (this.knownEqNames().includes(v)) {
            this.$root.find(`.b-eq[data-eq="${v}"]`).addClass('on');
        } else {
            // 정규 장비명이 아니면 기타 커스텀 입력으로 본다.
            this.$root.find('.b-eq--etc').addClass('on');
            $etc.prop('hidden', false).val(v);
        }
    }

    /* ── 체불금액 (숫자만 + 천단위 콤마 + 만/억 병기 힌트) ──
     * 입력 중  : 칸에는 "123,123", 아래 힌트에 한글 단위 읽기 "12만 3,123원".
     * 입력 마침: 칸을 떠나면 칸 안에 "123,123 원" 으로 붙여 보여주고 힌트는 접는다. 다시 누르면 숫자만 남겨 이어서 고친다.
     * 다음 칸  : 숫자 키보드의 확인키(enterkeyhint=next) 를 누르면 피해내용으로 간다. 값이 채워졌다고 저절로 옮기지는
     *            않는다 — 금액은 자릿수가 정해져 있지 않아 "다 쳤다"를 화면이 알 수 없고, 저절로 옮기면 한 자리 더 치려던
     *            사람이 다음 칸에 숫자를 넣게 된다(2026-09-18 기획 논의). 서버 전송·필수 판정은 숫자만 뽑아 쓰므로 '원' 이 붙어도 같다.
     */
    bindAmount() {
        const $hint = this.$root.find('#b-amount-hint');
        const $in   = this.$root.find('[name="unpaid_amount"]');
        const toMan = (n) => this.formatKoreanMan(n);
        const digitsOf = (v) => String(v || '').replace(/[^0-9]/g, '');
        const showEditing = (el) => {   // 편집 상태: 콤마 숫자 + 힌트
            const d = digitsOf(el.value);
            el.value = d ? Number(d).toLocaleString() : '';
            const n = parseInt(d || '0', 10);
            $hint.text(n > 0 ? toMan(n) : '');   // 한글 단위 읽기만("2,131만 2,313원") — 콤마 숫자는 칸에 이미 보여 앞에 되풀이하지 않는다(2026-09-18 기획)
        };
        $in.on('input', function () { showEditing(this); });
        $in.on('focus', function () { showEditing(this); });
        $in.on('blur', function () {
            const d = digitsOf(this.value);
            this.value = d ? Number(d).toLocaleString() + ' 원' : '';   // 숫자와 단위 사이 한 칸(2026-09-18 기획)
            $hint.text('');
        });
        $in.on('keydown', (e) => {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            this.$root.find('[name="damage_desc"]').trigger('focus');
        });
    }

    // 200000 → "20만원", 150000000 → "1억 5,000만원"
    formatKoreanMan(n) {
        if (!n || n <= 0) return '';
        const eok = Math.floor(n / 100000000);
        const man = Math.floor((n % 100000000) / 10000);
        const rest = n % 10000;
        let out = '';
        if (eok)  out += eok.toLocaleString() + '억';
        if (man)  out += (out ? ' ' : '') + man.toLocaleString() + '만';
        if (rest) out += (out ? ' ' : '') + rest.toLocaleString();
        return out + '원';
    }

    /* ── 사업자등록번호 (123-45-67890) ────────────── */
    bindBizNo() {
        this.$root.find('[name="biz_no"]').on('input', function () {
            this.value = Util.coNumber(this.value);
        });
    }

    /* ── 체불 대상 (업체 / 업자(개인) / 둘 다) ──────────────────
     * 2026-10-12 기획(유과장 1-1). 고른 쪽의 이름 칸만 보이고 필수가 된다. 업자만이면 사업자등록번호·대표자명도 숨긴다.
     * 값은 hidden target_type(co|pn|both) — 서버(ReportController::badInfoFromRequest)가 같은 값으로 필수를 검사하고
     * 숨겨진 칸의 값은 버린다. 여기선 숨긴 칸의 값을 지우지 않는다 — 다시 켜면 돌아온다. */
    bindTarget() {
        this.$root.on('click', '.b-tgt__btn', (e) => {
            this.setTarget($(e.currentTarget).data('tgt'));
            this.updateNextBtn();
        });
        this.syncTarget();
    }

    target() { return String(this.$root.find('[name="target_type"]').val() || 'co'); }

    setTarget(t) {
        if (!['co', 'pn', 'both'].includes(t)) t = 'co';
        this.$root.find('[name="target_type"]').val(t);
        this.syncTarget();
    }

    // 토글 표시 + 대상별 칸(.b-fgroup[data-tgt]) 켜고 끄기
    syncTarget() {
        const t = this.target();
        this.$root.find('.b-tgt__btn').each((_, el) => {
            const on = $(el).data('tgt') === t;
            $(el).toggleClass('is-on', on).attr('aria-pressed', on ? 'true' : 'false');
        });
        this.$root.find('.b-fgroup[data-tgt]').each((_, el) => {
            const show = t === 'both' || $(el).data('tgt') === t;
            $(el).prop('hidden', !show);
            if (!show) $(el).find('.b-input').removeClass('is-invalid');
        });
    }

    // 대상에 따른 1단계 필수 이름 칸 — 업체만: 업체명 · 업자만: 업자명 · 둘 다: 둘 다
    requiredNameFields() {
        const t = this.target();
        return t === 'pn' ? ['person_name'] : (t === 'both' ? ['co_name', 'person_name'] : ['co_name']);
    }

    /* ── 스텝 네비게이션 ───────────────────────────── */
    bindNav() {
        $('#b-rnext').on('click', () => this.onNext());
        // 이전(2단계) — 폰 뒤로가기·상단 ‹ 와 같은 길: history.back() → popstate → 1단계. 단계 기록을 한 줄로 유지한다
        $('#b-rprev').on('click', () => history.back());
        // 진행바 — 지난 단계 칸을 누르면 그 단계로(2026-09-17 기획). 현재·다음 칸과 완료 뒤는 goStep 이 disabled 로 막아 여기 안 온다.
        // 2→1 은 이전 버튼·폰 뒤로가기와 같은 길(history.back → popstate → goStep(1)) — 단계 기록을 한 줄로 유지한다.
        this.$root.on('click', '.b-rprog__seg:not([disabled])', (e) => {
            const seg = parseInt(e.currentTarget.dataset.seg, 10);
            if (seg < this.step) history.back();
        });
        this.bindStepHistory();
    }

    // 단계 뒤로가기 (2026-09-14 QA — 2단계에서 폰 뒤로가기·상단 ‹ 를 누르면 1단계가 아니라 설정 등 이전 페이지로 나갔다).
    //   2단계로 넘어갈 때 히스토리 항목 {rstep:2} 를 하나 얹고, 그 항목이 빠지면(popstate) 1단계로 돌린다.
    //   완료(3단계)에서 뒤로가기는 제출한 2단계로 돌아가지 않고 내제보건으로 간다.
    //   약관 시트(Ui/BS)·주소 레이어(F/Postcode)도 같은 방식으로 자기 항목을 얹는다 — 그것들이 빠질 때는
    //   현재 항목이 아직 {rstep:2} 라 단계는 그대로다.
    bindStepHistory() {
        // 새로고침 등으로 단계 항목이 남은 채 1단계로 열리면 지운다 — 안 그러면 뒤로가기 한 번이 헛돈다
        if (history.state && history.state.rstep) history.replaceState(null, '', location.href);
        window.addEventListener('popstate', () => {
            const st = history.state || {};
            if (this.step === 3) { location.replace('/b/my'); return; }
            if (this.step === 2 && st.rstep !== 2) this.goStep(1, { fromPop: true });
        });
    }

    onNext() {
        if (this.step === 1) {
            if (!this.validateStep1()) return;
            this.saveDraft();   // 중간저장 (비동기, 실패해도 진행)
            this.goStep(2);
        } else if (this.step === 2) {
            if (!this.validateStep2()) return;
            this.confirmSubmit();
        } else {
            location.replace('/b/my');
        }
    }

    goStep(n, opt = {}) {
        const prev = this.step;
        this.step = n;
        this.$root.find('.b-rstep').removeClass('is-active');
        this.$root.find(`.b-rstep[data-step="${n}"]`).addClass('is-active');
        this.$root.find('.b-rprog__seg').each((i, el) => {
            $(el).toggleClass('is-on', (i + 1) <= n)
                 .prop('disabled', !((i + 1) < n && n !== 3));   // 지난 단계만 누를 수 있다 · 제출 완료 뒤엔 전부 잠금
        });
        $('#b-rstep-cur').text(n);
        // 제출중 걸어둔 네이티브 disabled 해제 (특히 Step3 확인은 항상 활성)
        $('#b-rnext').prop('disabled', false).text(n === 1 ? '다음' : n === 2 ? '제보하기' : '확인');
        $('#b-rprev').prop('hidden', n !== 2);   // 이전은 2단계에서만 (1단계는 나갈 곳이 페이지 밖, 완료는 되돌아갈 수 없음)
        this.updateNextBtn();   // 새 스텝의 필수항목 충족 여부로 활성화(클래스)
        this.$root.find('.b-scroll').scrollTop(0);

        // 단계 기록(bindStepHistory) — 뒤로가기로 들어온 호출은 이미 되감긴 상태라 건드리지 않는다
        if (!opt.fromPop) {
            if (n === 2 && prev === 1) history.pushState({ rstep: 2 }, '', location.href);
            else if (n === 3) history.replaceState({ rstep: 3 }, '', location.href);   // 제출 완료 — 2단계 자리를 완료로 바꿔 되돌아갈 수 없게
        }
    }

    /* ── 전화번호 (단일) ──────────────────────────────
     * 대표번호 1개만. MAX_PHONES=1 이라 추가(+)/삭제(−) 버튼은 렌더되지 않음.
     * 연락처 가져오기(.b-phone-ctc)는 유지. */
    renderPhones() {
        const $wrap = $('#b-phones');
        $wrap.empty();
        this.phones.forEach((val, i) => {
            const last = i === this.phones.length - 1;
            const row = $(`
                <div class="b-phone-row">
                    <input class="b-input b-phone" inputmode="tel" value="${Util.phoneNumber(val)}" placeholder="휴대폰 번호">
                    <button type="button" class="b-phone-ctc" title="연락처에서 가져오기" aria-label="연락처에서 가져오기">
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="7" r="3.5" stroke="currentColor" stroke-width="1.5"/><path d="M3 17c0-3.87 3.13-7 7-7s7 3.13 7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </button>
                    ${i > 0 ? '<button type="button" class="b-phone-btn" data-rm="' + i + '">−</button>' : ''}
                    ${last && this.phones.length < MAX_PHONES ? '<button type="button" class="b-phone-btn" data-add="1">+</button>' : ''}
                </div>`);
            $wrap.append(row);
        });
    }

    bindPhones() {
        const $wrap = $('#b-phones');
        $wrap.on('click', '[data-add]', () => { this.syncPhones(); this.phones.push(''); this.renderPhones(); });
        $wrap.on('click', '[data-rm]', (e) => {
            this.syncPhones();
            this.phones.splice(parseInt($(e.currentTarget).data('rm'), 10), 1);
            if (!this.phones.length) this.phones = [''];
            this.renderPhones();
        });

        // 입력 중 전화번호 포맷팅 (010-1234-5678)
        $wrap.on('input', '.b-phone', function () {
            this.value = Util.phoneNumber(this.value);
        });

        // 연락처(주소록)에서 번호 가져오기 — 선택 결과는 클릭한 행에 채운다
        $wrap.on('click', '.b-phone-ctc', (e) => {
            this._ctcTarget = $(e.currentTarget).closest('.b-phone-row').find('.b-phone');
            const A = $j.F && $j.F.App;
            if (A && typeof A.openAddressBook === 'function') A.openAddressBook();
        });
        // 주소록 콜백을 devil 폼으로 라우팅 (기본은 메인앱 ModalPhone 으로 향함)
        const A = $j.F && $j.F.App;
        if (A) {
            A.callbackAddressBook = (data) => {
                if (this._ctcTarget && data && data.phone) {
                    this._ctcTarget.val(Util.phoneNumber(data.phone));
                    this.syncPhones();
                }
            };
        }
    }

    syncPhones() {
        this.phones = $('#b-phones .b-phone').map((i, el) => $(el).val().trim()).get();
    }

    /* ── Daum 우편번호 ────────────────────────────── */
    bindPostcode() {
        // 공용 모듈 위임: [data-postcode] 인풋 클릭 → 검색 → 선택 주소 채움
        $j.F.Postcode.bindInputs(this.$root);
    }

    /* ── 증빙사진 업로드 (공용 $j.F.Upload) ──────────── */
    bindPhotos() {
        const self = this;
        // 완료 이벤트 수신 (앱=네이티브 피커 / 브라우저=파일input 폴백)
        $j.Common.EventBus.on($j.getNS(this), 'upload:image', (e, file) => self.onPhotoUploaded(file));
        // + 버튼 → 업로드 모듈 호출
        $('#b-photos').on('click', '#b-photo-add', function () {
            const remain = MAX_PHOTOS - self.imgIds.length;
            if (remain <= 0) { alert('사진은 최대 ' + MAX_PHOTOS + '장까지 등록할 수 있습니다.'); return; }
            $j.F.Upload.addPhotoHere({ tag: 'devil', context: 'reportDocs', max_sheet: remain });
        });
        $('#b-photos').on('click', '.b-photo-thumb__del', function () {
            const id = $(this).closest('.b-photo-thumb').data('img-id');
            self.imgIds = self.imgIds.filter((x) => x !== id);
            $(this).closest('.b-photo-thumb').remove();
            self.updatePhotoCount();
            self.updateNextBtn();
        });
    }

    // (2026-06-04) jb 본앱 프로토콜 정렬 — Defense.js 와 동일. 단건 가정으로 file.id
    //   접근 시 dv 앱이 보낸 배열을 못 받음(W-1). DiaryPhotoBase 의 Array.isArray + forEach 채택.
    onPhotoUploaded(payload) {
        if ($j.F.Upload.getContext() !== 'reportDocs') return;   // 다른 화면 업로드 무시
        (Array.isArray(payload) ? payload : [payload]).forEach(file => {
            if (!file?.id) return;
            if (this.imgIds.length >= MAX_PHOTOS) return;
            this.imgIds.push(file.id);
            const url  = file.host ? Util.getImageUrl(file.path, file.host, 'original') : '';
            $('#b-photo-add').before(`<div class="b-photo-thumb" data-img-id="${Util.escapeHtml(file.id)}"><img src="${Util.escapeHtml(url)}"><button type="button" class="b-photo-thumb__del">✕</button></div>`);
            this.updatePhotoCount();
            this.updateNextBtn();
        });
    }

    updatePhotoCount() {
        $('#b-photos .b-photo-add__cnt').text(this.imgIds.length + '/' + MAX_PHOTOS);
    }

    /* ── 동의 ─────────────────────────────────────── */
    // 2026-09-14 기획(엑셀 106·107) — 전체동의 없음, 체크박스를 눌러 바로 체크하지 않는다.
    // 항목을 누르면 약관 시트가 열리고, 내용을 끝까지 내려야 '동의합니다'가 켜진다 → 누르면 그 항목만 체크.
    bindAgree() {
        this.$root.find('.b-agree').on('click', (e) => {
            const $row = $(e.currentTarget);
            const i = parseInt($row.data('agree'), 10);
            $j.F.Devil.Terms.viewConsent($row.data('code'), {
                agreed: !!this.agreed[i],
                onAgree: () => { this.agreed[i] = true; this.renderAgree(); },
            });
        });
    }

    renderAgree() {
        this.$root.find('.b-agree').each((i, el) => $(el).toggleClass('is-on', !!this.agreed[i]));
        this.syncAuthGate();
        this.updateNextBtn();
    }

    /**
     * 동의 3건을 다 받기 전에는 인증번호를 보낼 수 없다 (2026-09-23).
     * 동의 없이 발송되면 "동의하기 전에 알림톡이 먼저 나간" 것이 되어 동의를 받는 의미가 없다.
     * 반려 재제출(authSkipped)은 동의 구간 자체가 숨겨지므로 잠그지 않는다.
     */
    syncAuthGate() {
        const $send = $('#b-rauth-send');
        if (!$send.length || this.authSkipped) return;
        $send.prop('disabled', !this.agreed.every(Boolean));
    }

    /* ── 본인인증 ─────────────────────────────────── */
    bindAuth() {
        const $card  = $('#b-rauth');
        const $phone = $('#b-rauth-phone');
        const $send  = $('#b-rauth-send');
        const $code  = $('#b-rauth-code');
        const $msg   = $('#b-rauth-msg');
        if (!$card.length) return;

        // 회원 휴대폰이 미리 들어있다(서버). 숫자만 온 값을 010-0000-0000 으로.
        // 칸은 readonly — 회원정보 번호로만 인증을 받는다(2026-09-14 기획, 서버도 회원 번호와 대조).
        $phone.val(Util.phoneNumber($phone.val()));

        // 세션에 유효한 인증이 남아 있으면(임시저장 이어쓰기·새로고침) 처음부터 완료 상태
        if (String($card.data('verified')) === '1') this.setAuthVerified();

        this.syncAuthGate();   // 동의 전에는 발송 버튼을 잠근 채로 시작

        $send.on('click', () => {
            if (!this.authSkipped && !this.agreed.every(Boolean)) {
                this.toast('약관에 모두 동의해 주세요.');
                return;
            }
            const ph = ($phone.val() || '').replace(/[^0-9]/g, '');
            if (!/^01[0-9]{8,9}$/.test(ph)) { this.toast('장비불러 회원정보에 휴대폰 번호가 없어요. 장비불러 앱 내정보에서 등록해 주세요.'); return; }

            $send.prop('disabled', true);
            $.ajax({ url: '/b/ajax/report/auth/send', type: 'POST', data: { phone: ph }, dataType: 'json' })
                .done((res) => {
                    $send.prop('disabled', false);
                    if (!res || !res.result) {
                        const m = (res && res.message) || '인증번호 발송에 실패했습니다.';
                        this.setAuthMsg(m, 'err');
                        this.toast(m);
                        return;
                    }
                    this.authSent = true;
                    this.authVerified = false;
                    $('#b-rauth-code-row').prop('hidden', false);
                    $code.val('');
                    $send.text('재발송').addClass('is-resend');
                    // dev 전용 — 알림톡이 실제로 안 나가는 환경에선 서버가 코드를 같이 내려준다(운영 응답엔 없다)
                    if (res.dev_code) this.setAuthMsg(`[개발] 인증번호: ${res.dev_code}`, 'err');
                    else this.setAuthMsg('알림톡으로 받은 인증번호 6자리를 입력해 주세요.', 'ok');
                    this.startAuthTimer(parseInt(res.ttl, 10) || parseInt($card.data('ttl'), 10) || 180);
                    setTimeout(() => $code.trigger('focus'), 200);
                    this.updateNextBtn();
                })
                .fail((xhr) => {
                    $send.prop('disabled', false);
                    // 429 = 서버 속도 제한(routes/devil.php throttle) — '오류'가 아니라 잠시 기다리라고 말한다
                    this.toast(xhr && xhr.status === 429 ? '요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요.' : '인증번호 발송 중 오류가 발생했습니다.');
                });
        });

        $code.on('input', () => $code.val(($code.val() || '').replace(/[^0-9]/g, '').slice(0, 6)));

        $('#b-rauth-confirm').on('click', () => {
            const c = ($code.val() || '').trim();
            if (!this.authSent) { this.toast('인증번호를 먼저 발송해 주세요.'); return; }
            if (!/^[0-9]{6}$/.test(c)) { this.toast('인증번호 6자리를 입력해 주세요.'); $code.focus(); return; }

            $('#b-rauth-confirm').prop('disabled', true);
            $.ajax({ url: '/b/ajax/report/auth/verify', type: 'POST', data: { code: c }, dataType: 'json' })
                .done((res) => {
                    $('#b-rauth-confirm').prop('disabled', false);
                    if (!res || !res.result) {
                        const m = (res && res.message) || '인증번호가 일치하지 않습니다.';
                        this.setAuthMsg(m, 'err');
                        this.toast(m);
                        return;
                    }
                    this.setAuthVerified();
                })
                .fail((xhr) => {
                    $('#b-rauth-confirm').prop('disabled', false);
                    this.toast(xhr && xhr.status === 429 ? '요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요.' : '인증 확인 중 오류가 발생했습니다.');
                });
        });
    }

    setAuthMsg(text, kind) {
        $('#b-rauth-msg').text(text).toggleClass('is-err', kind === 'err').toggleClass('is-ok', kind === 'ok');
    }

    // 인증 완료 화면 — 번호·발송 잠그고 인증번호 칸 대신 '인증 완료' 띠
    setAuthVerified() {
        this.authVerified = true;
        this.stopAuthTimer();
        $('#b-rauth').addClass('is-verified');
        $('#b-rauth-phone').prop('disabled', true);
        $('#b-rauth-send').prop('disabled', true).text('인증발송').removeClass('is-resend');
        $('#b-rauth-code-row').prop('hidden', true);
        $('#b-rauth-done').prop('hidden', false);
        $('#b-rauth-msg').prop('hidden', true);
        this.updateNextBtn();
    }

    // 서버 AUTH_TTL(3분)과 같은 카운트다운. 0 이 되면 안내만 바꾼다(재발송은 버튼으로).
    startAuthTimer(ttl) {
        this.stopAuthTimer();
        let sec = ttl;
        const tick = () => {
            const m = Math.floor(sec / 60), ss = sec % 60;
            $('#b-rauth-timer').text(`${m}:${String(ss).padStart(2, '0')}`);
            if (sec <= 0) {
                this.stopAuthTimer();
                this.setAuthMsg('인증번호가 만료되었습니다. 재발송해 주세요.', 'err');
                return;
            }
            sec--;
        };
        tick();
        this.authTimer = setInterval(tick, 1000);
    }

    stopAuthTimer() {
        if (this.authTimer) clearInterval(this.authTimer);
        this.authTimer = null;
        $('#b-rauth-timer').text('');
    }

    /* ── 검증 ─────────────────────────────────────── */
    validateStep1() {
        this.syncPhones();
        const fields = [...this.requiredNameFields(), 'damage_day', 'car_type', 'work_place', 'unpaid_amount', 'damage_desc'];
        let ok = true, $first = null;

        fields.forEach((name) => {
            const $el = this.$root.find(`[name="${name}"]`);
            const v = ($el.val() || '').trim();
            $el.toggleClass('is-invalid', !v);
            if (!v && ok) { ok = false; $first = $el; }
        });

        const $p0 = $('#b-phones .b-phone').eq(0);
        if (!($p0.val() || '').trim()) {
            $p0.addClass('is-invalid');
            if (ok) { ok = false; $first = $p0; }
        } else { $p0.removeClass('is-invalid'); }

        if (!ok) {
            this.toast('필수 항목을 입력해주세요.');
            $first && $first.focus();
            return false;
        }

        // 체불금액 0원은 등록할 수 없다(2026-10-28 대표님). 서버(ReportController::store)도 0 이하를 거절하지만
        // '필수값이 누락되었습니다' 일반 문구라 왜 막혔는지 알 수 없었다 — 여기서 칸을 표시하고 바로 알린다.
        const $amt = this.$root.find('[name="unpaid_amount"]');
        const amount = parseInt(String($amt.val() || '').replace(/[^0-9]/g, '') || '0', 10);
        $amt.toggleClass('is-invalid', amount <= 0);
        if (amount <= 0) {
            this.toast('체불금액을 입력해 주세요. 0원은 등록할 수 없습니다.');
            $amt.focus();
            return false;
        }

        // 입력 규칙 — 서버(DvReportRules::firstError)와 같은 규칙. 어긋난 칸 하나를 표시하고 그 칸의 안내문을 띄운다
        const bad = this.ruleError();
        if (bad) {
            bad.$el.addClass('is-invalid');
            this.toast(bad.msg);
            bad.$el.focus();
            return false;
        }
        return true;
    }

    /* ── 입력 규칙 (서버 app/Services/Devil/DvReportRules.php 와 같은 규칙) ──────────────
     * 2026-11-04 CS 지적 — 업체명에 전화번호·"1"·"모름", 번호 한 자리 빠진 010 10자리가 그대로 등록됐다.
     * 단어 목록은 서버가 data-rules 로 내려 준다(한 곳에서만 관리). 정규식·자릿수는 여기와 서버가 같은 식.
     * 여기선 바로 알려 주는 것이고 최종 판정은 서버 — 서버가 거절하면 그 안내문이 alert 로 뜬다. */
    rules() {
        if (!this._rules) {
            this._rules = Object.assign({ placeholders: [], abusiveName: [], abusiveDesc: [], descMin: 10 }, this.$root.data('rules') || {});
        }
        return this._rules;
    }

    // 휴대폰 — 010 은 11자리만, 그 외 01X 는 10~11자리. 확실한 가짜(같은 숫자 반복·0000·1234…)는 거절
    phoneError(d) {
        if (!d) return '';
        if (d.startsWith('010')) {
            if (d.length !== 11) return '휴대폰 번호 11자리를 정확히 입력해 주세요.';
        } else if (!/^01[1-9][0-9]{7,8}$/.test(d)) {
            return '휴대폰 번호(010…)만 입력할 수 있습니다.';
        }
        const body = d.slice(3);
        if (/^(\d)\1+$/.test(body) || body.startsWith('0000') || body === '12345678' || body === '12340000') {
            return '올바른 휴대폰 번호를 입력해 주세요.';
        }
        return '';
    }

    // 업체명(co)·업자명(pn)·대표자명(ceo) — 글자 2자 이상, 전화번호·숫자 금지, 자리 채우는 말·직함만·비방어 거절
    nameError(name, kind) {
        if (!name) return '';
        const r = this.rules();
        const label = { co: '업체명', pn: '업자명', ceo: '대표자명' }[kind] || '업체명';
        const what = kind === 'co' ? '상호' : '이름';
        const compact = name.replace(/\s+/g, '').toLowerCase();

        if (/0\d{1,2}[-. ]?\d{3,4}[-. ]?\d{4}/.test(name)) return `전화번호는 휴대폰번호 칸에 적어 주세요. ${label}에는 ${what}만 적습니다.`;
        if ((name.match(/[가-힣a-zA-Z]/g) || []).length < 2) return `${label}은 한글 또는 영문 2자 이상으로 입력해 주세요.`;
        if (r.placeholders.includes(compact) || /^[가-힣]?(사장|소장|대표|대표이사|반장|팀장|실장|부장|과장|이사|현장소장)(님)?$/.test(compact)) {
            if (kind === 'co')  return "업체를 모르면 체불대상에서 '체불업자'를 선택하고 이름을 적어 주세요.";
            if (kind === 'ceo') return '대표자명을 모르면 비워 두세요.';
            return '체불업자의 실제 이름을 입력해 주세요.';
        }
        if (kind !== 'co' && /\d/.test(name)) return `${label}에는 숫자 없이 이름만 적어 주세요.`;
        if (r.abusiveName.some((w) => compact.includes(w))) return `${label}에는 ${what}만 적어 주세요. 비방·욕설 표현은 등록할 수 없습니다.`;
        return '';
    }

    // 사업자등록번호 검증식 — 가중치 1,3,7,1,3,7,1,3,5 + 9번째×5의 십의 자리
    bizNoValid(d) {
        if (!/^\d{10}$/.test(d)) return false;
        const w = [1, 3, 7, 1, 3, 7, 1, 3, 5];
        let sum = 0;
        for (let i = 0; i < 9; i++) sum += Number(d[i]) * w[i];
        sum += Math.floor(Number(d[8]) * 5 / 10);
        return (10 - sum % 10) % 10 === Number(d[9]);
    }

    // 1단계 전체 — 어긋난 첫 칸 {$el, msg}. 없으면 null. 순서는 서버 firstError 와 같다
    ruleError() {
        const r = this.rules();
        const val = (name) => (this.$root.find(`[name="${name}"]`).val() || '').trim();
        const $f = (name) => this.$root.find(`[name="${name}"]`);
        const tgt = this.target();
        let msg = '';

        let $badPhone = null;
        $('#b-phones .b-phone').each((_, el) => {
            if ($badPhone) return;
            const m = this.phoneError(String($(el).val() || '').replace(/[^0-9]/g, ''));
            if (m) { $badPhone = $(el); msg = m; }
        });
        if ($badPhone) return { $el: $badPhone, msg };

        if (tgt !== 'pn' && (msg = this.nameError(val('co_name'), 'co')))     return { $el: $f('co_name'), msg };
        if (tgt !== 'co' && (msg = this.nameError(val('person_name'), 'pn'))) return { $el: $f('person_name'), msg };
        if (tgt !== 'pn' && (msg = this.nameError(val('ceo_name'), 'ceo')))   return { $el: $f('ceo_name'), msg };

        const biz = val('biz_no').replace(/[^0-9]/g, '');
        if (tgt !== 'pn' && biz && !this.bizNoValid(biz)) return { $el: $f('biz_no'), msg: '사업자등록번호를 다시 확인해 주세요.' };

        const day = val('damage_day');
        const now = new Date();
        const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        if (day && !/^\d{4}-\d{2}-\d{2}$/.test(day)) return { $el: $f('damage_day'), msg: '작업일을 다시 선택해 주세요.' };
        if (day && day > today) return { $el: $f('damage_day'), msg: '작업일은 오늘 이후 날짜를 선택할 수 없습니다.' };

        const desc = val('damage_desc');
        if (desc && desc.length < r.descMin) return { $el: $f('damage_desc'), msg: `피해내용을 ${r.descMin}자 이상 적어 주세요.` };
        const dcompact = desc.replace(/\s+/g, '');
        if (desc && r.abusiveDesc.some((w) => dcompact.includes(w))) return { $el: $f('damage_desc'), msg: '피해내용에 욕설 표현이 있습니다. 사실만 적어 주세요.' };

        return null;
    }

    validateStep2() {
        if (!this.imgIds.length) { this.toast('증빙사진을 1장 이상 등록해주세요.'); return false; }
        if (!this.agreed.every(Boolean)) { this.toast('필수 동의 항목에 모두 동의해주세요.'); return false; }
        if (!this.isAuthOk()) { this.toast('휴대폰 본인인증을 완료해주세요.'); $('#b-rauth-send').trigger('focus'); return false; }
        return true;
    }

    /* 토스트 안내 (악덕알리미 테마 — window.BD.toast, 없으면 alert 폴백) */
    toast(msg) {
        if (window.BD && typeof window.BD.toast === 'function') window.BD.toast(msg);
        else alert(msg);
    }

    /* ── 중간저장 (임시저장, DRAFT) ───────────────── */
    saveDraft() {
        this.syncPhones();
        const val = (name) => (this.$root.find(`[name="${name}"]`).val() || '').trim();
        const phones = this.phones.filter(Boolean);
        const payload = {
            draft_num: this.draftNum || 0,
            target_type: this.target(),   // co|pn|both (2026-10-12 기획 1-1)
            co_name: val('co_name'),
            person_name: val('person_name'),
            phone: phones[0] || '',   // 대표(호환)
            phones: phones,           // 전체 전화(다중번호)
            biz_no: val('biz_no'),
            ceo_name: val('ceo_name'),
            address: val('address'),
            address_detail: val('address_detail'),     // 선택 입력
            damage_day: val('damage_day'),
            car_type: val('car_type'),
            work_place: val('work_place'),
            work_place_detail: val('work_place_detail'), // 선택 입력
            unpaid_amount: val('unpaid_amount').replace(/[^0-9]/g, ''),
            damage_desc: val('damage_desc'),
        };
        $.ajax({ url: '/b/ajax/report/draft', type: 'POST', data: payload })
            .done((res) => { if (res && res.result && res.num) this.draftNum = res.num; });
    }

    /* ── 제출 전 확인 (2026-10-12 대표님·유과장님 확정) ──────────
     * 허위·과장 제보의 책임이 본인에게 있음을 한 번 더 묻고, 제출하면 업체에 안내 문자가 간다는 것을 알린다.
     * 발송 '시각'은 적지 않는다 — 안내장은 관리자가 [정정진행]으로 수동 발송하므로 시각을 약속할 수 없다.
     * 면책 문구(2026-10-30 대표님·CS 확정) — 책임 문장 다음 줄. 소명 페이지(Defense/screens.js rAuthFirst)와 같은 문장이고,
     * desc 는 pre-line 이라 \n 이 줄바꿈으로 보인다. */
    confirmSubmit() {
        $j.Ui.Dialog.open({
            tone:    'danger',
            title:   '이 내용으로 제보할까요?',
            desc:    '허위·과장 제보의 책임은 제보자 본인에게 있습니다.\n'
                   + '장비불러는 제출된 자료를 전달할 뿐, 대금을 받아 주거나 사실 여부를 판단·보증하지 않습니다.',
            emph:    '제보하면 체불업체(자)에게 정정·지급 기회 안내 문자가 발송됩니다.',
            confirm: '제보하기',
            cancel:  '취소',
        }).then((ok) => { if (ok) this.submit(); });
    }

    /* 같은 번호로 낸 제보가 있을 때 — 같은 업체에 별개 체불이 있을 수 있어 막지 않고 회원에게 확인받는다.
     * 확인은 이번 재전송에만 실린다. 내용을 고쳐 다시 내면 서버가 다시 검사한다. */
    confirmDuplicate(dups) {
        const $next = $('#b-rnext').prop('disabled', false).text('제보하기');
        $j.Ui.Dialog.open({
            tone:    'warn',
            align:   'left',
            title:   '같은 번호로 낸 제보가 있습니다',
            desc:    '같은 체불을 다시 제보하면 금액이 두 번 잡힙니다. 다른 작업의 체불일 때만 제보해 주세요.',
            rows:    (dups || []).map((d) => ({
                k: `#${d.num} · ${d.type}`,
                v: `${d.damage_day || '피해일 없음'} · ${Number(d.unpaid_amount).toLocaleString()}원`,
            })),
            confirm: '다른 건입니다',
            cancel:  '취소',
        }).then((ok) => {
            if (ok) this.submit(true);
            else $next.focus();
        });
    }

    /* ── 제출 ─────────────────────────────────────── */
    submit(dupConfirmed = false) {
        this.syncPhones();
        const val = (name) => (this.$root.find(`[name="${name}"]`).val() || '').trim();
        const phones = this.phones.filter(Boolean);

        const payload = {
            draft_num: this.draftNum || 0,
            target_type: this.target(),   // co|pn|both (2026-10-12 기획 1-1)
            co_name: val('co_name'),
            person_name: val('person_name'),
            phone: phones[0] || '',   // 대표(호환)
            phones: phones,           // 전체 전화(다중번호)
            biz_no: val('biz_no'),
            ceo_name: val('ceo_name'),
            address: val('address'),
            address_detail: val('address_detail'),     // 선택 입력
            damage_day: val('damage_day'),
            car_type: val('car_type'),
            work_place: val('work_place'),
            work_place_detail: val('work_place_detail'), // 선택 입력
            unpaid_amount: val('unpaid_amount').replace(/[^0-9]/g, ''),
            damage_desc: val('damage_desc'),
            img_ids: this.imgIds,
            dup_confirmed: dupConfirmed ? 1 : 0,   // 중복 경고에서 "다른 건입니다" 를 눌렀는지
            // 동의서 3종 값(코드 → 1/0) — 서버가 이 값을 보고서야 '동의' 로 기록한다 (화면 가드만으로는 입증이 안 된다)
            agree: Object.fromEntries(this.$root.find('.b-agree').toArray().map((el, i) => [$(el).data('code'), this.agreed[i] ? 1 : 0])),
        };

        $('#b-rnext').prop('disabled', true).text('제출 중…');
        $.ajax({ url: '/b/ajax/report', type: 'POST', data: payload })
            .done((res) => {
                if (res && res.need_dup_confirm) {
                    this.confirmDuplicate(res.dups);
                    return;
                }
                if (!res || !res.result) {
                    alert((res && res.message) || '제보 접수에 실패했습니다.');
                    $('#b-rnext').prop('disabled', false).text('제보하기');
                    // 서버 세션의 인증이 사라짐(30분 경과·세션 만료) → 화면도 미인증으로 되돌려 다시 받게
                    if (res && res.need_auth) this.resetAuth();
                    return;
                }
                this.goStep(3);
            })
            .fail(() => {
                alert('제보 접수에 실패했습니다.');
                $('#b-rnext').prop('disabled', false).text('제보하기');
            });
    }

    // 인증 상태 초기화 — 서버가 '인증 필요'로 거절했을 때
    resetAuth() {
        this.authSent = false;
        this.authVerified = false;
        this.stopAuthTimer();
        $('#b-rauth').removeClass('is-verified');
        $('#b-rauth-phone').prop('disabled', false);
        $('#b-rauth-send').prop('disabled', false).text('인증발송').removeClass('is-resend');
        $('#b-rauth-code-row').prop('hidden', true);
        $('#b-rauth-done').prop('hidden', true);
        $('#b-rauth-msg').prop('hidden', false);
        this.setAuthMsg('인증이 만료되었어요. 인증번호를 다시 받아 주세요.', 'err');
        this.updateNextBtn();
    }

    /* ── 임시·반려건 프리필 (텍스트 필드) ─────────── */
    prefill(num) {
        $.getJSON('/b/ajax/report/' + num).done((res) => {
            if (!res || !res.result) return;
            const r = res.report || {};

            // 반려(REJECTED) 재작성: 첫 제출 때 이미 동의했으므로 동의 항목 숨김 + 동의완료 처리
            if ((r.status || '') === 'REJECTED') {
                this.agreed = [true, true, true];
                this.authSkipped = true;   // 본인인증도 첫 제출 때 받았다
                this.stopAuthTimer();
                $('#b-agree-section').hide();
            }

            let info = {};
            try { info = typeof r.bad_info === 'string' ? JSON.parse(r.bad_info) : (r.bad_info || {}); } catch (e) {}

            const set = (name, v) => { if (v) this.$root.find(`[name="${name}"]`).val(v); };
            // 체불 대상 복원 — 옛 저장건(키 없음)은 업체만. '업체명' 키가 없는 옛 건은 '이름' 이 곧 업체명
            const tgt = info['체불대상'] || 'co';
            this.setTarget(tgt);
            set('co_name', info['업체명'] !== undefined ? info['업체명'] : (tgt === 'pn' ? '' : info['이름']));
            set('person_name', info['업자명']);
            set('biz_no', info['사업자번호']);
            set('ceo_name', info['대표자명']);
            set('address', info['사업장주소']);
            set('damage_day', info['피해일']);
            set('car_type', info['작업장비']);
            set('work_place', info['작업지주소']);
            set('unpaid_amount', r.unpaid_amount);
            set('damage_desc', r.damage_desc);
            // 금액 콤마 / 사업자번호 포맷 적용
            this.$root.find('[name="unpaid_amount"], [name="biz_no"]').trigger('input');
            this.$root.find('[name="unpaid_amount"]').trigger('blur');   // 복원된 금액도 입력 마침 모양("123,123원")으로
            this.syncCarTypeTile();   // 복원된 작업장비 타일 선택표시

            // 전화 복원 — 단일 번호. 과거 다중 저장건도 대표번호 하나만 채운다.
            const ph0 = (Array.isArray(info.phones) && info.phones.length) ? info.phones[0]
                      : (info['연락처'] || '');
            if (ph0) { this.phones = [ph0]; this.renderPhones(); }

            // 기존 증빙사진(REPORT) 복원 — imgIds + 썸네일 (반려 수정·임시 이어작성 시 누락 방지)
            (res.photos || []).forEach((p) => {
                if ((p.photo_type || '') !== 'REPORT') return;
                const id = parseInt(p.img_id, 10);
                if (!id || this.imgIds.includes(id)) return;
                this.imgIds.push(id);
                const url = p.thumb_url || p.image_url || '';
                $('#b-photo-add').before(`<div class="b-photo-thumb" data-img-id="${id}"><img src="${Util.escapeHtml(url)}"><button type="button" class="b-photo-thumb__del">✕</button></div>`);
            });
            this.updatePhotoCount();

            this.updateNextBtn();   // 복원된 값으로 버튼 활성화 반영
        });
    }
}
